import React, { useState, useEffect } from 'react';

/**
 * Inline-таймер обратного отсчёта до истечения YK-ссылки.
 * Показывается внутри кнопки «Оплатить N ₽ · MM:SS».
 *
 * @param {string|null} generatedAt — ISO-timestamp создания ссылки (Order.payment_url_generated_at).
 * @param {number} ttlMin — TTL ссылки в минутах (по умолчанию 60). Backend кенсит на 61
 *   как буфер для clock skew, но клиенту показываем ровно 60 мин.
 *
 * Если generatedAt отсутствует — компонент ничего не рендерит (старые заказы без поля).
 * Если время истекло — показывает «истёк» серым.
 */
function PaymentTimer({ generatedAt, ttlMin = 60 }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!generatedAt) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [generatedAt]);

  if (!generatedAt) return null;

  const expiresMs = new Date(generatedAt).getTime() + ttlMin * 60 * 1000;
  const remaining = expiresMs - now;

  if (remaining <= 0) {
    return <span style={{ opacity: 0.75, marginLeft: 6, fontWeight: 'inherit' }}>· истёк</span>;
  }

  const totalSec = Math.floor(remaining / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;

  return (
    <span style={{ opacity: 0.85, marginLeft: 6, fontWeight: 'inherit' }}>
      · {m}:{String(s).padStart(2, '0')}
    </span>
  );
}

export default PaymentTimer;
